import styles from './styles.module.scss'
import labelStyles from '../shared/fieldLabel.module.scss'
import fieldWrapperStyles from '../shared/fieldWrapper.module.scss'
import validationStyles from '../shared/validation.module.scss'
import { useState } from 'react'
import classNames from 'classnames'

type TextareaProps = {
  id: string
  name: string
  required?: boolean
  placeholder?: string
  disabled?: boolean
  value: string | undefined
  maxLength?: number
  textPosition?: 'left' | 'right' | 'center'
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void
  errorText?: string | null
}

export function RawTextareaField({
  id,
  name,
  required = false,
  placeholder,
  disabled = false,
  value,
  maxLength = 200,
  textPosition = 'left',
  errorText,
  onChange
}: TextareaProps) {
  const [focused, setFocused] = useState(false)
  const charCount = value?.toString().length

  const hasValue =
    value !== undefined &&
    value !== null &&
    (typeof value === 'number' || String(value).trim().length > 0)

  const isActive = focused || hasValue

  const textareaClasses = classNames(styles.Textarea, styles[textPosition], {
    [styles.disabled]: disabled,
    [styles.focused]: isActive,
    [styles.error]: !!errorText && !disabled
  })

  const labelClasses = classNames({
    [labelStyles.disabled]: disabled,
    [labelStyles.focused]: isActive,
    [labelStyles.required]: required
  })

  return (
    <div className={fieldWrapperStyles.FieldWrapperTextarea}>
      <label
        htmlFor={id}
        className={`${labelStyles.FieldLabel} ${
          labelStyles.FieldLabelTextarea
        } ${labelStyles.FieldLabel__fluid} ${
          isActive ? labelStyles.focused : ''
        }`}
      >
        <span className={`${labelStyles.FieldLabel__name} ${labelClasses}`}>
          {name}
        </span>
      </label>
      <div className={styles.FieldLabelCount}>
        {charCount} / {maxLength}
      </div>
      <textarea
        id={id}
        aria-label={name}
        placeholder={placeholder}
        onFocus={() => !disabled && setFocused(true)}
        onBlur={() => !disabled && setFocused(false)}
        className={textareaClasses}
        autoComplete="off"
        disabled={disabled}
        onChange={onChange}
      />
      {errorText && !disabled && (
        <div className={validationStyles.ErrorMessage} role="alert">
          {errorText}
        </div>
      )}
    </div>
  )
}
